export const CALCOM_ATOMS_WRAPPER_CLASS = "calcom-atoms";
